export default "__VITE_ASSET__CrAeRT1P__"